"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyCouponList = void 0;

var react_1 = require("@emotion/react");

var constants_1 = require("../../constants");

exports.emptyCouponList = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media (max-width: ", "px) {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  @media (min-width: ", "px) {\n    margin-bottom: 85px;\n    margin-top: 56px;\n  }\n"])), constants_1.BREAK_POINT.MOBILE, constants_1.BREAK_POINT.MOBILE);